var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('keep-alive',[(_vm.isShow)?_c('mainD',{key:_vm.$route.fullPath,on:{"upMain":_vm.upMain}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }